import api from './api';

export const getCategories = async () => {
  const response = await api.get('/categories');
  return response.data;
};

export const getCategory = async (slug) => {
  const response = await api.get(`/categories/${slug}`);
  return response.data;
};

